const formatUnit = (unit) =>
  unit.toLocaleString("en-US", { maximumFractionDigits: 2 })

export default formatUnit
